import React from "react";

const Layout = ({ children }) => {
  return (
    <>
      <main
        role="main"
        className="container-fluid d-flex flex-column justify-content-center align-items-center w-100 flex-1 py-md"
      >
        {children}
      </main>
    </>
  );
};

export default Layout;
